/* ------------------------------------------------------------------------ */
/*		File: cmpCard_360.tsx                                               */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React from "react";
import { ICard } from "./cmpCard_360.d";
import { getImage } from "../../components/GenericComponents/functions";
import "./cmpCard_360.css"

/* ------------------------------------------------------------------------ */


const Card_360_Horizontal: React.FC<ICard> = ({card}: ICard) => {
    return (
        <div className="card_360_content_h">
            <div className="card_360_content_h_blue" />

            <div className="card_360_content_h_detail">
            <img className="card_360_img" src={getImage(card.src)} alt={card.src} />
                <div className="card_360_content_label">{card.label}</div>
                <div className="card_360_content_h_detail_two">{card.description}</div>
            </div>
        </div>
    )
}

const Card_360_Vertical: React.FC<ICard> = ({card}: ICard) => {
    return (
        <div className="card_360_content_v">
            <div className="card_360_content_row">
                <img className="card_360_img" src={getImage(card.src)} alt={card.src} />
                <div className="card_360_content_label">{card.label}</div>
                <div className="card_360_content_line" />       
                <div className="card_360_content_v_description">{card.description}</div>
                {card.discount !== null && (
                    <div className="card_360_card_group_circle">
                        <div className="card_360_card_group_circle_white"/>
                        <div className="card_360_card_group_circle_text">{card.discount}</div>
                        <div className="card_360_card_group_circle_text">{card.off}</div>
                    </div>
                )}
            </div>

            {card.links !== null &&  (
                <div className="card_360_content_v_blue">
                    {card.links?.map((item, index) => (
                        <img 
                            key={`img-${index}`}
                            src={getImage(item.src)} 
                            alt={item.src} 
                            onClick={() => window.open(item.url)}
                        />
                    ))}            
                </div>
            )}      
        </div>
    )
}


const Card_360: React.FC<ICard> = ({card}: ICard) => {
    return (
        <div className="card_360">
            {
                card.orientation?.toUpperCase() === "HORIZONTAL" 
                ? <Card_360_Horizontal card={card} />
                : <Card_360_Vertical card={card} />
            }
        </div>
    );
};
  
export default Card_360;